<div class="formulario">

  <div class="Titulo" style="text-align: center;"> <h3>Mis existencias</h3></div>
  <hr>

  <div class="form-row mt-5">

    <div class="form-group col-md-3" style="padding-left:120px;">
        <label for="inputPassword4">Plantel</label>
        <select [(ngModel)]="opcionSeleccionado" id="areaEmite" class="form-control" name="Plantel" (change)="plantelSeleccionado()" required ngModel #Plantel="ngModel">       
          <ng-container *ngFor="let plantel of planteles" >
                <option [value]="plantel.id">{{plantel.descripcion}}</option>
          </ng-container>
          </select>
          <small *ngIf="Plantel.invalid && Plantel.touched" class="form-text text-danger animated fadeIn">Campo Obligatorio</small>
    </div>

    <div class="form-group col-md-3" style="padding-left:80px;">
        <label for="inputPassword4">Descargar Inventario</label> <br>
        <button class="btn btn-success" (click)="reporteGneral()"><span class="mdi mdi-file-pdf" style="color: brown;"></span> .PDF</button>
    </div>

    <div class="form-group col-md-2">
        <label for="inputPassword4">Formato requisición</label> <br>
        <button class="btn btn-danger" (click)="descargarFormato()"><span class="mdi mdi-file-pdf" style="color: rgb(226, 222, 222);"></span> .PDF</button>
    </div>
     
  </div>

</div>

<!-- lista de productos a surtir -->

<div class="mt-2" style="width: 85%;margin: 0 auto;" >

    <table id="articulos" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table" style="width: 100%;">
        <thead>
            <tr style="color:#000">
                <!-- <th style="text-align:center;width:auto">Num.</th> -->
                <th style="text-align:left;width:auto">Partida</th>
                <th style="text-align:left;width:auto">Artículo</th>
                <th style="text-align:center;width:30px">Existencia</th> 
                <th *ngIf="botonUtilizaArticulo" style="text-align:center;width: 80px;">Utilizar artículo</th>    
            </tr>
        </thead>
        <tbody style="font-size: 15px;">
            <tr *ngFor="let existencia of existencias">
                <!-- <td style="text-align:center;"></td> -->
                <td style="text-align:left;">{{existencia.partida}}</td>
                <td style="text-transform:capitalize">{{existencia.descripcion}}</td>
                <td style="text-align:center;">{{existencia.existencias}}</td>     
                <td *ngIf="botonUtilizaArticulo" style="text-align:center;">
                    <button class="btn btn-light" title="usar artículo" data-toggle="modal" data-target="#exampleModal" (click)="PasarCantidadDisponible(existencia.existencias,existencia.id_costos)"><i class="mdi mdi-poll" style="color: brown;"></i></button>
                    <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal"></button> -->
                </td>                          
            </tr>
        </tbody>
    </table>
   
</div>

<!-- MODAL -->

<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Usar Artículo</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <form (ngSubmit)="AsignarArticulo(f)" #f="ngForm" >
          
          <div class="form-group">
            <label  for="autoriza-name" class="col-form-label">Nombre de quien autoriza:</label>
            <input [(ngModel)]=" UsarArticulo.nombreAutoriza" type="text" name="nomAutoriza" readonly class="form-control" id="autoriza-name">
          </div>

           <div class="form-group">
            <label for="autoriza-name" class="col-form-label">Nombre de quien solicita:</label>
            <input [(ngModel)]=" UsarArticulo.nombreSolicita" type="text" name="nomSolicita" class="form-control" id="autoriza-name">
          </div>

           <div class="form-group">
            <label for="cantidad-name" class="col-form-label">Cantidad Disponible:</label>
            <input [(ngModel)]=" UsarArticulo.cantidadDisponible" type="number" name="cantidadDisponible" readonly class="form-control" id="cantidad-name">
          </div>

          <div class="form-group">
            <label for="cantidad-name" class="col-form-label">Cantidad a utilizar:</label>
            <input [(ngModel)]=" UsarArticulo.cantidadAUtilizar" type="number" name="cantidadUtilizar" class="form-control" id="cantidad-name">
          </div>

           <div class="form-group">
            <label for="cantidad-name" class="col-form-label">Observación (opcional):</label>
            <input [(ngModel)]=" UsarArticulo.observacion" type="text" name="observacion" class="form-control" id="cantidad-name">
          </div>

           <div class="form-group">
            <label for="cantidad-name" class="col-form-label">Fecha de autorización:</label>
            <input [(ngModel)]=" UsarArticulo.fecha" type="text" name="fecha" readonly class="form-control" id="cantidad-name">
          </div>

          <button class="btn btn-success">Autorizar</button>

        </form>
      </div>
    </div>
  </div>
</div>